import { ThemeProviderStyles } from './ThemeProvider.types';
import { Theme } from '../../themes';

export const useStyles = (theme: Theme): ThemeProviderStyles => {
  const styles: ThemeProviderStyles = {
    sidebar: {
      '*': {
        '::-webkit-scrollbar': { width: '17px', height: '17px' },
        '::-webkit-scrollbar-thumb': {
          border: '6px solid rgba(0, 0, 0, 0)',
          backgroundClip: 'padding-box',
          WebkitBorderRadius: '20px',
          backgroundColor: theme.palette.action.primary,
        },
      },
    },
  };

  return styles;
};
